import { http } from '@/plugins/http'
import { checkStatus, getHeaders, parseJSON, buildUrl } from '../../utils/api'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_CACHED_PARAM,
  RECEIVING_CACHED_PARAM,
  RECEIVE_CACHED_PARAM_FAILURE,
  SAVING_CACHED_PARAM,
  SAVING_CACHED_PARAM_FAILURE
} from '../mutationTypes'
import handleXHRError from '../../utils/helpers/HandleXHRError'

const cachedParamSchema = new schema.Entity('cachedParams')
// const cachedParamListSchema = new schema.Array(cachedParamSchema)

const state = {
  data: {},
  receivingCachedParam: null,
  receiveCachedParamFailure: null,
  saving: { status: false, err: null }
}

const actions = {
  saveCachedParam (store, payload) {
    const instanceUrl = this.getters.getActiveInstance.url
    const data = { data: payload }
    this.commit(SAVING_CACHED_PARAM, true)
    if (payload) {
      return http.post(buildUrl('reports/params', null, instanceUrl), data, { headers: getHeaders(this.getters.getToken) })
        .then(checkStatus)
        .then(parseJSON)
        .then(r => {
          if (r) {
            this.commit(SAVING_CACHED_PARAM, false)
            const { entities, result } = normalize(r, cachedParamSchema)
            if (!result) {
              return this.commit(RECEIVE_CACHED_PARAM, r)
            }
            this.commit(RECEIVE_CACHED_PARAM, entities.cachedParams)
            return r
          }
        })
        .catch(e => {
          return this.commit(SAVING_CACHED_PARAM_FAILURE, handleXHRError(e))
        })
    } else {
      return this.commit(SAVING_CACHED_PARAM, false)
    }
  }
}

// getters (like selectors in Redux)
const getters = {
  getCachedParams: (state, rootState) => {
    return state.data
  },
  getCachedParamById: (state) => (id) => {
    return state.data[id]
  }
}

const mutations = {
  [RECEIVE_CACHED_PARAM] (state, results) {
    if (!results || !Object.keys(results).length) {
      return state.data
    }
    if (state.data && Object.keys(state.data).length) {
      state.data = Object.assign({}, state.data, results)
    } else {
      state.data = results
    }
  },
  [RECEIVING_CACHED_PARAM] (state, payload) {
    state.receivingCachedParam = payload
  },
  [RECEIVE_CACHED_PARAM_FAILURE] (state, payload) {
    state.receiveCachedParamFailure = payload
  },
  [SAVING_CACHED_PARAM] (state, payload) {
    state.saving = { status: payload, err: null }
  },
  [SAVING_CACHED_PARAM_FAILURE] (state, payload) {
    state.saving = { status: false, err: payload }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
